const InfoFinanciera = ({ cuenta, errors, onChange }) => {
  const inputClass = (field) =>
    `w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 ${
      errors[`cuentasBancarias.0.${field}`] ? 'border-red-500 ring-2 ring-red-100' : 'border-slate-300'
    }`;

  const selectClass = inputClass;

  const handleNumeroCuentaChange = (e) => {
    let value = e.target.value.replace(/[^\d]/g, '');
    if (value.length > 20) value = value.slice(0, 20);
    onChange(e.target.name, value);
  };

  const handleCciChange = (e) => {
    let value = e.target.value.replace(/[^\d]/g, '');
    if (value.length > 20) value = value.slice(0, 20);
    onChange(e.target.name, value);
  };

  return (
    <div className="ui-card p-5 md:p-6">
      <div className="mb-4 flex items-center gap-3 border-b border-slate-200 pb-3">
        <div className="h-8 w-1.5 rounded-full bg-red-600" />
        <h3 className="text-base font-semibold uppercase tracking-[0.08em] text-slate-800">INFORMACIÓN FINANCIERA</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Número de Cuenta */}
        <div>
          <label htmlFor="financiera-numeroCuenta" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            NÚMERO DE CUENTA
          </label>
          <input
            id="financiera-numeroCuenta"
            name="financiera.numeroCuenta"
            value={cuenta?.numeroCuenta || ''}
            onChange={handleNumeroCuentaChange}
            className={inputClass('numeroCuenta')}
            inputMode="numeric"
            placeholder="10 A 20 DÍGITOS"
            autoComplete="off"
          />
          {errors['cuentasBancarias.0.numeroCuenta'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['cuentasBancarias.0.numeroCuenta'][0]}</p>
          )}
        </div>
        {/* CCI */}
        <div>
          <label htmlFor="financiera-cci" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            CCI
          </label>
          <input
            id="financiera-cci"
            name="financiera.cci"
            value={cuenta?.cci || ''}
            onChange={handleCciChange}
            className={inputClass('cci')}
            inputMode="numeric"
            placeholder="20 DÍGITOS"
            autoComplete="off"
          />
          {errors['cuentasBancarias.0.cci'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['cuentasBancarias.0.cci'][0]}</p>
          )}
        </div>
        {/* Entidad Financiera */}
        <div>
          <label htmlFor="financiera-entidadFinanciera" className="mb-1 block text-xs font-semibold uppercase tracking-[0.08em] text-slate-600">
            ENTIDAD FINANCIERA
          </label>
          <select
            id="financiera-entidadFinanciera"
            name="financiera.entidadFinanciera"
            value={cuenta?.entidadFinanciera || ''}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            className={selectClass('entidadFinanciera')}
          >
            <option value="">SELECCIONE...</option>
            <option value="BCP">BCP</option>
            <option value="INTERBANK">INTERBANK</option>
            <option value="SCOTIABANK">SCOTIABANK</option>
            <option value="BBVA">BBVA</option>
            <option value="BANCO DE LA NACION">BANCO DE LA NACIÓN</option>
            <option value="BANCO PICHINCHA">BANCO PICHINCHA</option>
            <option value="MIBANCO">MIBANCO</option>
            <option value="BANBIF">BANBIF</option>
            <option value="FALABELLA">FALABELLA</option>
            <option value="CAJA PIURA">CAJA PIURA</option>
            <option value="CAJA AREQUIPA">CAJA AREQUIPA</option>
            <option value="CAJA HUANCAYO">CAJA HUANCAYO</option>
            <option value="CAJA TRUJILLO">CAJA TRUJILLO</option>
            <option value="CAJA CUSCO">CAJA CUSCO</option>
          </select>
          {errors['cuentasBancarias.0.entidadFinanciera'] && (
            <p className="mt-1 text-xs font-medium text-red-600">{errors['cuentasBancarias.0.entidadFinanciera'][0]}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoFinanciera;
